import React from 'react';

import './RouteLine.scss';

const RouteLine = () => (
    <svg
        className="RouteLine"
        id="routeLine"
        x="0px"
        y="0px"
        height="1440px"
        width="1920px"
        viewBox="0 0 1920 1440"
        style={{ enableBackground: 'new 0 0 1920 1440' }}
    >
        <path
            id="routeLinePath"
            className="st0"
            d="M288,720v-10.2l33.6,6l-14.7-69.1l48.3-10.5l4.1,24.2l38.4-7.9L401,620l56,8.5l-7.5,66.4
            c-0.1,0.5,76,4.8,83.1,5c16.5,0.5,33,0.5,49.4,0.3c13.6-0.1,27.5-0.5,41,2c15.3,2.9,25.7,11.3,32.8,24.8
            c5.5,10.5,10.8,21.7,23.2,23.8c16.2,2.7,32.1,6.8,47.7,12c14.3,4.8,28.6,11.1,43.5,14c13.2,2.6,26.5,0,39.5-2.7
            c15.4-3.2,30.4-7.9,44.6-15c9.3-4.7,22-13,32.7-11.7c8.2,1,16.1,4.9,23.5,8.7c6.8,3.4,14.3,6.4,20.2,11.3c4.1,3.4,7.7,7.5,12,10.8
            c6.5,4.9,15.1,4.8,22.2,8.5c7.3,3.8,13.5,9.4,20.6,13.5c6.8,3.9,14.1,7.1,20.9,11.2c4.8,2.8,9.9,6.6,15.3,8.1
            c4.8,1.3,10.5,0.3,15.4,0c6.5-0.4,12.9-0.1,19.4,0c15.1,0.3,29.6-4.3,44.1-8.2c17.2-4.5,33.5-12.2,49.2-20.9
            c14-7.7,26.5-18.7,39.1-28.6c13.4-10.5,26.7-21.2,41.1-30.2c7.1-4.4,12.3-9.1,18.6-14.6c4.6-4.1,10.1-6.7,15.8-8.5
            c7.3-2.4,13.4-8.1,21-9.6c8-1.6,15.6-1.8,23.4-5c3.6-1.5,5.8-4.9,8.4-7.8c3.9-4.4,7.7-9,11.6-13.5c1-1.1,1.9-2.2,3-3.3
            c4.6-4.4,14.7-10.4,21.1-10.4c8.4,0,16.9,0,25.4-0.1c7.3,0,10.3,5.5,16.7,8.3c6.9,3.1,16.3,1.2,23.7,1.3c5.9,0,12.4-6.1,17.5-9.2
            c6.9-4.4,13.9-8.6,20.9-12.7c7-4,14.1-8,21.4-11.2c8.5-3.8,14.8-3.6,23.8-3.3c4,0.1,8.3-0.3,12.2,0.8c11.4,3.1,14.6,19.5,17.2,29.1
            c5.9,21.8,32.1,34,40.6,40.8c21.6,17.4,43.5-0.3,60,17.6"
        />
    </svg>
);

export default RouteLine;
